export default [
	{
		path: 'login',
		component: () => import('../../views/platform/login'),
		meta: {
			title: '登录页面'
		}
	}, 
	{
		path: 'AppLogin',
		component: () => import('../../views/platform/AppLogin'),
		meta: {
			title: '登录页面'
		}
	},
	{
		path: 'logout',
		component: () => import('../../components/login/logout')
	}, {
		path: 'logoutUser',
		component: () => import('../../components/login/logoutUser')
	}, {
		path: 'Unauthorized',
		component: () => import('../../components/login/Unauthorized'),
		meta: {
			title: '无授权'
		}
	},
	{
		path: 'singleLogin',
		component: () => import('../../views/platform/singleLogin'),
		meta: {
			title: '单点登录页面'
		}
	}
]